/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useState } from "react";
import "../administracion.css";
import { Button } from "primereact/button";
import formReducer from "../../shared/forms/formReducer";
import FormHandler from "../../shared/forms/formHandler";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import FieldInputNumber from "../../shared/controls/fieldInputNumber";
import FieldCalendar from "../../shared/controls/fieldCalendar";
import FieldTextArea from "../../shared/controls/fieldTextArea";
import FieldCheckBox from "../../shared/controls/fieldCheckBox";
import vacacionesValidacionEsquema from "./vacacionesValidacionEsquema";
import useApiVacaciones from "../../api/administracion/useApiVacaciones";
import alerts from "../../shared/alerts";

const DetalleVacaciones = ({
  vacacionesId,
  onSave,
  close,
  soloLectura,
  esquemaPago,
}) => {
  const api = useApiVacaciones();

  const defaultEntity = () => ({
    entity: {
      id: 0,
      editable: true,
      vacacionesTrabajadas: false,
    },
  });

  const [{ entity, errors }, dispatch] = useReducer(
    formReducer,
    {},
    defaultEntity,
  );

  const [empleado, setEmpleado] = useState({});

  const formHandler = new FormHandler({
    validationSchema: vacacionesValidacionEsquema,
    api,
    dispatch,
  });

  useEffect(() => {
    async function cargar() {
      const vacaciones = await api.obtener(vacacionesId);

      dispatch({
        type: "update",
        value: vacaciones,
      });
    }

    if (vacacionesId > 0) {
      cargar().then();
    }
  }, []);

  const actualizar = (value, propertyName) => {
    dispatch({
      type: "update",
      value,
      name: propertyName,
    });
  };

  const obtenerDiasParaSolicitar = (datosEmpleado) => {
    const diasPendientes = datosEmpleado?.diasPendientesDisfrute ?? 0;

    if (diasPendientes > 0) {
      return diasPendientes;
    }

    return datosEmpleado?.diasDisponibles ?? 0;
  };

  const actualizarEmpleado = async (value, propertyName) => {
    if (value != null) {
      const datosEmpleado = await api.datosEmpleado({
        empleadoId: value.id,
      });

      setEmpleado(datosEmpleado);

      const diasPendientes = datosEmpleado?.diasPendientesDisfrute ?? 0;

      if (diasPendientes > 0) {
        actualizar(false, "vacacionesTrabajadas");
      }

      const diasParaSolicitar = obtenerDiasParaSolicitar(datosEmpleado);

      if (diasParaSolicitar <= 0) {
        alerts.aviso(
          "El empleado no tiene días disponibles para solicitar vacaciones",
        );
      }
    } else {
      setEmpleado({});
      actualizar(false, "vacacionesTrabajadas");
    }

    actualizar(value, propertyName);
  };

  const guardar = async () => {
    const diasParaSolicitar = obtenerDiasParaSolicitar(empleado);

    if (entity.empleado && diasParaSolicitar <= 0) {
      alerts.aviso(
        "El empleado no tiene días disponibles para solicitar vacaciones",
      );
      return;
    }

    if (entity.empleado && Number(entity.dias) > diasParaSolicitar) {
      alerts.aviso(
        `El empleado solamente puede solicitar ${diasParaSolicitar} días`,
      );
      return;
    }

    await formHandler.save(entity);

    if (formHandler.valdation.result) {
      onSave();
    }
  };

  return (
    <>
      <div
        className="form-container full-height"
        style={{ paddingLeft: "1px" }}
      >
        {entity.id === 0 ? (
          <div className="form-row">
            <h5 className="col-12">Vacaciones</h5>

            <FieldDropDown
              key={`empleado-${esquemaPago}`}
              name="empleado"
              source="empleados"
              params={{ esquemaPago }}
              errors={errors}
              label="Empleado"
              colSm={12}
              value={entity.empleado}
              onChange={actualizarEmpleado}
              filter
            />
            <div className="col-sm-8" />

            <FieldInputNumber
              name="dias"
              label="Días"
              value={entity.dias}
              colSm={4}
              errors={errors}
              onChange={actualizar}
            />

            <div className="col-sm-4 d-flex flex-column justify-content-center pl-2">
              <div>
                <b>Días Permitidos</b>
              </div>

              <div>{empleado?.diasPorAntiguedad ?? 0}</div>
            </div>

            <div className="col-sm-4 d-flex flex-column justify-content-center">
              <div>
                <b>Días Disponibles</b>
              </div>

              <div>{empleado?.diasDisponibles ?? 0}</div>
            </div>

            <div className="col-sm-4 d-flex flex-column justify-content-center">
              <div>
                <b>Días pendientes de disfrute</b>
              </div>

              <div>{empleado?.diasPendientesDisfrute ?? 0}</div>
            </div>

            <FieldCalendar
              name="fechaPago"
              label="Fecha Pago"
              colSm={4}
              value={entity.fechaPago}
              className="xs"
              showButtonBar={false}
              errors={errors}
              onChange={actualizar}
            />

            <div className="col-8">
              <label>Fecha de Vacaciones</label>

              <div className="d-flex">
                <FieldCalendar
                  name="fechaInicio"
                  value={entity.fechaInicio}
                  showButtonBar={false}
                  className="xs"
                  errors={errors}
                  onChange={actualizar}
                />

                <FieldCalendar
                  name="fechaRegreso"
                  value={entity.fechaRegreso}
                  showButtonBar={false}
                  className="xs"
                  errors={errors}
                  onChange={actualizar}
                />
              </div>
            </div>

            <FieldTextArea
              name="nota"
              label="Nota"
              value={entity.nota}
              colSm={12}
              onChange={actualizar}
              rows={4}
              errors={errors}
            />

            <FieldCheckBox
              name="vacacionesTrabajadas"
              value={entity.vacacionesTrabajadas}
              className="m-0"
              onChange={actualizar}
              label="Vacaciones Trabajadas"
              colSm={12}
              disabled={(empleado?.diasPendientesDisfrute ?? 0) > 0}
            />
          </div>
        ) : (
          <>
            <div className="bg-light p-3">
              <div>{entity.empleado}</div>

              <div className="adm-resumen vacaciones">
                <div>
                  <div>
                    <b>Fecha Ingreso</b>
                  </div>

                  <div>{entity.fechaIngreso}</div>
                </div>

                <div>
                  <div>
                    <b>Antigüedad</b>
                  </div>

                  <div>{entity.antiguedad}</div>
                </div>

                <div>
                  <div>
                    <b>Días p/Antigüedad</b>
                  </div>

                  <div>{entity.diasPorAntiguedad}</div>
                </div>

                <div>
                  <div>
                    <b>Días Tomados</b>
                  </div>

                  <div>{entity.diasTomados}</div>
                </div>

                <div>
                  <div>
                    <b>Días Disponibles</b>
                  </div>

                  <div>{entity.diasDisponibles}</div>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <table className="table align-middle">
                <thead className="thead-light">
                  <tr>
                    <th className="center" style={{ width: "35%" }}>
                      Fecha Solicitados
                    </th>

                    <th className="center" style={{ width: "15%" }}>
                      Días
                    </th>

                    <th className="center" style={{ width: "25%" }}>
                      Vacaciones Trabajadas
                    </th>

                    <th />
                  </tr>
                </thead>

                <tbody>
                  {entity.historial?.map((item, index) => (
                    <tr className="text-center" key={index}>
                      <td>{item.fecha}</td>
                      <td>{item.dias}</td>

                      <td>
                        <FieldCheckBox
                          value={item.vacacionesTrabajadas}
                          disabled
                          colMd={12}
                          className="justify-content-center"
                        />
                      </td>

                      <td>{item.estatus}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <div className="form-footer">
        <Button label="Salir" className="p-button-outlined" onClick={close} />

        {entity.id === 0 && !soloLectura && (
          <Button
            className="btn-primary"
            label="Solicitar"
            type="button"
            onClick={guardar}
          />
        )}
      </div>
    </>
  );
};

export default DetalleVacaciones;
